module.exports = __webpack_public_path__ + "static/petitorio-bruno-cuadrado-86e1e5831d50bca0476012d1b9d3a6ec.jpeg";